import { httpCall, httpFetch } from "../../common/util";
import * as qs from 'qs';
import WorkkardDetailActionApiMapping from "../WorkkardDetail/actionURLMapping";
import config from './endpoints';
import { normalizeAssociatedWorkkardListItem } from '../../common/normalizers/associatedWorkkard';
import { getAuthHeaders } from "@/utils/authManager";
import { buildUrl } from "../../config/apiEndpoints";

const ep = config.api.endpoints;

const apiGet = (endpoint, params) =>
  httpCall({
    method: endpoint.method,
    headers: { "Content-Type": "application/json" },
    ...(params !== undefined
      ? { [endpoint.method === "GET" ? "params" : "data"]: params }
      : {}),
    url: endpoint.gateway ? `${endpoint.url}` : endpoint.url,
  });

export const getWorkkardDetailMasterData = (payload) =>
  apiGet(ep.masterData, { cId: payload.cId });

export const getActivityListByClaim = (payload) =>
  apiGet(ep.activityListing, {
    skip: payload.skip || 0,
    rows: payload.take || 15,
    cId: payload.cId,
    sortBy: "4",
  });

export const getActivityNoteTemplates = (payload) =>
  apiGet(ep.activityNoteTemplates, { actIds: payload.actIds });

export const getActivityWatcherList = (actId) =>
  apiGet(ep.activityWatcherList, { actId });

export const getWorkkardWatcherList = (cId, sponsorId) =>
  apiGet(ep.workkardWatcherList, { workkardId: cId, sponserId: sponsorId });

export const getAssociatedWorkkardList = (wkId, tmplType, selectedFilter, row, skip, take, orgids) => {
  const pageSize = take || 20;
  const pageNumber = skip ? Math.floor(skip / pageSize) + 1 : 1;
  const organizationIds = orgids
    ? orgids.split(',').map(Number)
    : [];

  return apiGet(ep.associatedWorkkard, {
    workkard_id: Number(wkId),
    selected_filter: selectedFilter,
    organization_ids: organizationIds,
    page_number: pageNumber,
    page_size: pageSize,
    only_count: false
  }).then((response) => {
    if (!response) return response;
    return {
      status: response.status,
      Total: response.total,
      FilterValue: response.filter_value,
      Data: (response.results || []).map(normalizeAssociatedWorkkardListItem)
    };
  });
};

export const fetchFilters = (TemplateType, WkkdId, selectedFilter) =>
  apiGet(ep.associatedWorkkardFilter, { template_type: TemplateType }).then((response) => {
    if (!response) return response;
    return {
      status: response.status,
      Data: response.results || [],
      Filter: response.filter || []
    };
  });

export const getActivityDetail = (actId) =>
  apiGet(ep.activityDetail, { actId });

export const getActivityTemplates = (payload) =>
  apiGet(ep.activityTemplatesList, { wkid: payload.wkid });

export const getAllNoteTemplates = (payload) => {
  const moduleId = payload.moduleId || payload.templateId;
  let {method, url} = ep.allNoteTemplates;
  url = `${url}/${payload.nttype}/${moduleId}`;
  return apiGet({url, method}).then((response)=>{
    if (!response) return response;
    const noteTemplates = (response.noteTemplates || []).map((template) => ({
      Id: template.id,
      OrganizationId: template.organizationId,
      Module: template.module,
      NoteTemplateName: template.name,
      TemplateShortName: template.shortName,
      TemplateDescription: template.description,
      SequenceNumber: template.sequence,
      TemplateId: template.moduleTemplateId,
      TemplateType: template.moduleTemplateType,
      TemplateName: template.moduleTemplateName,
      IsActive: template.isActive,
      IsDefault: template.isDefault,
      IsShared: template.isShared,
      IsVisible: template.isVisible,
      IsSystem: template.isSystem,
      IsAssociated: template.isAssociated
    }));
    return {
      ...response,
      Data: {
        NoteTemplates: noteTemplates,
        ActivityData: null,
        WorkkardData: null
      }
    };
  });
};

// export const getAllDraftsCount = (ActionType) => {
//   return httpCall({
//     method: WorkkardDetailActionApiMapping[ActionType].method,
//     headers: {
//       "Content-Type": "application/json"
//     },
//     url: WorkkardDetailActionApiMapping[ActionType].url
//   });
// };

export const getSelectedNoteTemplateData = (payload) => {
  let {method, url} = ep.selectedNoteTemplateFields;
  return httpCall({
    method: method,
    headers: getAuthHeaders(),
    url: `${url}${payload.moduleType}/${payload.moduleId}?template_id=${payload.notetemplateId}`
  });
};
// http://localhost:8180/1.0/note/composer/W/480619?template_id=3456
// export const getAllDraftNotes = (ActionType) => {
//   return httpCall({
//     method: WorkkardDetailActionApiMapping[ActionType].method,
//     headers: {
//       "Content-Type": "application/json"
//     },
//     url: WorkkardDetailActionApiMapping[ActionType].url
//   });
// };

// export const publishSavedNote = (ActionType, payload) => {
//   return httpCall({
//     method: WorkkardDetailActionApiMapping[ActionType].method,
//     headers: {
//       "Content-Type": "application/json"
//     },
//     params: payload,
//     url: WorkkardDetailActionApiMapping[ActionType].url
//   });
// };

// export const deleteSavedNote = (ActionType, payload) => {
//   return httpCall({
//     method: WorkkardDetailActionApiMapping[ActionType].method,
//     headers: {
//       "Content-Type": "application/json"
//     },
//     params: { nId: payload.nId },
//     url: WorkkardDetailActionApiMapping[ActionType].url
//   });
// };

export const changeNoteType = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: { nid: payload.noteId, did: payload.draftId },
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const changeNoteCreationActivityTemplate = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: { ...payload },
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getCloseActivityOpenDiaries = (payload) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: `/god?${qs.stringify(payload)}`
  })
);

export const getCloseActivityNotification = (payload) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: `/gauid?${qs.stringify(payload)}`
  })
);

//POST Requests
// export const discardSelectedNoteTemplate = (payload) => {
//   return httpFetch({
//     url: '/disdrnt',
//     method: 'post',
//     credentials: "include",
//     data: payload
//   })
// };

export const publishDraftNote = (payload) => {
  return httpFetch({
    url: '/pubdn',
    method: 'post',
    credentials: "include",
    data: payload
  })
};

export const saveDraftNote = (payload) => {
  return httpFetch({
    url: '/savdrnt',
    method: 'post',
    credentials: "include",
    data: payload
  })
};

export const cloneToDraftNote = (payload) => {
  return httpFetch({
    url: '/gcldn',
    method: 'post',
    credentials: "include",
    data: payload
  })
};

export const editDraftNote = (payload) => {
  return httpFetch({
    url: '/gedn',
    method: 'post',
    credentials: "include",
    data: payload
  })
};

export const getNotesData = (request = {}) => {
  const endpoint =
    request.type === "workkard" ? ep.middlePanelWorkkardNotes : ep.middlePanelNotes;

  const params = {
    type: request.type,
    cId: request.cId,
    actId: request.actId || 0,
    skip: request.skip || 0,
    take: request.take || 10,
  };
  if (request.reviewFilter !== undefined && request.reviewFilter !== null) {
    params.reviewFilter = request.reviewFilter;
  }
  if (request.noteFilters) {
    params.noteFilters = request.noteFilters;
  }
  if (request.noteId) {
    params.noteId = request.noteId;
  }

  return apiGet(endpoint, params).then((response) => {
    if (!response) return response;
    const data = Array.isArray(response.data) ? response.data : [];
    return {
      status: response.status,
      data,
      total: response.total ?? data.length,
      recordCount: response.record_count ?? data.length,
      skip: response.skip ?? params.skip,
      take: response.take ?? params.take,
    };
  });
};

export const getFilesData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getWorkkardFilesData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getDiariesData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getWorkkardDiariesData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getWorkkardTodoOwners = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getLogData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getWorkkardLogData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  })
}

export const getPartiesData = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const postActivityReassigne = (payload) => {
  return httpFetch({
    url: '/reaioactapi',
    method: 'post',
    credentials: "include",
    data: payload
  })
}

// export const updateActivityInProgress = (payload) => {
//   return httpFetch({
//     url: '/aaapubn',
//     method: 'post',
//     credentials: "include",
//     data: payload
//   })

// }

// export const writeNoteReview = (payload) => {
//   return fetch('/rn', {
//     method: 'post',
//     credentials: "include",
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache', 'pragma': 'no-cache' },
//     body: qs.stringify(payload)
//   })
//     .then(response => response.json());
// }

export const writeNoteReview = (payload) => {
  return httpCall({
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: "/1.0/rn"
  });
};

const resolveCaptionModule = (category) => {
  const value = (category || '').toLowerCase();  
  if (value.includes('workkardnote')) return 'wrk_note';
  if (value.includes('workkard')) return 'wrk';
  if (value.includes('activitynote')) return 'note';
  if (value.includes('activityfile')) return 'act';
  if (value.includes('activity')) return 'act';
  return 'note';
};

export const updateFileCaption = (payload) => {
  const module = resolveCaptionModule(payload.category);
  return httpCall({
    method: "PUT",
    headers: { 'Content-Type': 'application/json' },
    params: { caption: payload.caption },
    url: `/1.0/update/caption/${module}/${payload.id}`
  });
};

export const changeDiarieTitle = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};


export const changeDiarieDueDate = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};
export const changeDiarieActionComplete = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};


export const changeDiarieActionCancelled = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getCombinedViewDatacvfatCall = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getCombinedViewDatacvfuCall = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getCombinedViewDatacvgsCall = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const getCombinedViewDatacvpCall = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};


export const getCombinedViewWorkkardFilesCall = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const fetchWorkardFilesReference = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const fetchWorkardLetters = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials: true,
    url: `${WorkkardDetailActionApiMapping[ActionType].url}/${payload.cId}`,
    baseURL: `${process.env.UrlScheme}://${process.env.LetterSubDomain}.${process.env.RootUrl}/`
  });
};


export const saveCombinedViewSettings = (ActionType, settings) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    data: settings,
    url: WorkkardDetailActionApiMapping[ActionType].url
  })
}

export const postActivityMenuActionsRequest = (payload) => {
  return httpFetch({
    url: '/aaapubn',
    method: 'post',
    credentials: "include",
    data: payload
  })
};

export const bulkCompleteOpenDiaries = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: { diariesData: payload },
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const changeactivityupdatestatus = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const getOpenActivities = (payload) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: `/goa?${qs.stringify(payload)}`
  })
);

export const getUserAllOpenDiaries = (payload) => {
  const take = Number(payload.take) || 30;
  const skip = Number(payload.skip) || 0;
  const pageNo = Math.floor(skip / take) + 1;
  return httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: `/1.0/clmtodo?${qs.stringify({ cId: payload.wkkdID, status: 'open', page_no: pageNo })}`
  });
};

// export const getUserAllUnreadNotifications = (payload) => (
//   httpCall({
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     url: `/gaus?${qs.stringify(payload)}`
//   })
// );

export const closeWorkkardCompleteDiaries = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const closeWorkkardCloseActivities = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const closeWorkkardPostRequest = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const closeWorkkardPermissionRequest = (ActionType) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};
export const saveAndUpdateFileCaption = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const updateWorkkardField = (ActionType, payload) => {
    return httpFetch({
      url: WorkkardDetailActionApiMapping[ActionType].url,
      method: WorkkardDetailActionApiMapping[ActionType].method,
      credentials: "include",
      data: payload
    });
}

export const fetchWorkkardCarrier = () => apiGet(ep.workkardCarrier);

export const fetchWorkkardTemplateFields = (shortName) => httpCall({
  method: 'GET',
  headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  url: `/1.0/template/workkard/${shortName}/fields?render_type=edit`,
});

export const updateWorkkardTemplateFields = (workkardId, data) => httpCall({
  method: 'PUT',
  headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  url: `/1.0/workkard/update/${workkardId}`,
  data,
});

export const fetchActivityTemplateFields = (shortName) => httpCall({
  method: 'GET',
  headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  url: `/1.0/template/activity/${shortName}/fields?render_type=edit`,
});

export const updateActivityTemplateFields = (activityId, data) => httpCall({
  method: 'PUT',
  headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  url: `/1.0/activity/update/${activityId}`,
  data,
});

export const setUserTourStatus = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  url: WorkkardDetailActionApiMapping[ActionType].url
});
export const getUserTourStatus = (ActionType) => httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      'Content-Type': 'application/json'
    },
    url: WorkkardDetailActionApiMapping[ActionType].url
  });

export const getActivityReassignRequest = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const deleteAssociatedParty = (ActionType, payload) => httpCall({
  method: WorkkardDetailActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: WorkkardDetailActionApiMapping[ActionType].url
});

export const getPrintCombinedViewData = (ActionType, payload) =>  {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      "Content-Type": "application/json"
    },
    params: payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
};

export const fetchReOpenReasonList = (templateId) =>
  apiGet(ep.reOpenReasonList, { templateId });

export const updateActivityField = (ActionType, payload) => {
  return httpFetch({
    url: WorkkardDetailActionApiMapping[ActionType].url,
    method: WorkkardDetailActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
}

export const fetchContactInsuredDetails = (payload) =>
  apiGet(ep.contactInsuredDetails, payload);

export const fetchShareProposalDetails = (payload) =>
  apiGet({
    ...ep.shareProposalDetails,
    url: buildUrl(ep.shareProposalDetails.url, { workkard_id: payload.cId }),
  });

export const shareProposal = ({ cId, ...body }) =>
  apiGet(
    {
      ...ep.shareProposal,
      url: buildUrl(ep.shareProposal.url, { workkard_id: cId }),
    },
    body
  );

export const saveContactInsuredDetails = (ActionType, payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:payload,
    url: WorkkardDetailActionApiMapping[ActionType].url
  });
}

export const getTimezoneByZip = (ActionType,payload) => {
  return httpCall({
    method: WorkkardDetailActionApiMapping[ActionType].method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:payload,
    url: `${WorkkardDetailActionApiMapping[ActionType].url}?${qs.stringify(payload)}`
  });
}

// export const getCloseAtivityPermission = (ActionType, payload) => httpCall({
//   method: WorkkardDetailActionApiMapping[ActionType].method,
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded'
//   },
//   params: payload,
//   url: WorkkardDetailActionApiMapping[ActionType].url
// });

export const updateUserCustomFieldData = (ActionType, payload) => {
  return httpFetch({
    url: WorkkardDetailActionApiMapping[ActionType].url,
    method: WorkkardDetailActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
}
export const resetUserCFData = (ActionType, payload) => {
  return httpFetch({
    url: WorkkardDetailActionApiMapping[ActionType].url,
    method: WorkkardDetailActionApiMapping[ActionType].method,
    credentials: "include",
    data: payload
  });
}

export const updateUserPinnedFields = (ActionType, payload) => {
  return httpCall({
    url: WorkkardDetailActionApiMapping[ActionType].url,
    method: WorkkardDetailActionApiMapping[ActionType].method,
    data: payload
  });
}
